import { SET_TAB_VALUE } from './types';
import {tabIndexes} from '../../models/TabIndexes'

export function setTabValue(tabValue: tabIndexes) {
  return {
    type: SET_TAB_VALUE,
    payload: tabValue,
  };
}
